module.exports = __webpack_public_path__ + "img/user-edit-orange.38b75756.svg";